import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line
import classNames from "classnames";

import Label from "../label";

class Badge extends React.Component {
  render() {
    const {
      size,
      margin,
      theme,
      className,
      style,
      children,

      mutted,
      strong,
      slim,
      text,
      upper,
      lower,

      ...extraProps
    } = this.props;

    const label = React.createElement(
      Label,
      {
        margin: "no",
        size,
        theme,
        mutted,
        strong,
        slim,
        text,
        upper,
        lower
      },
      children
    );

    const badgeClasses = classNames(
      "badge",
      {
        [size]: size,
        [`margin-${margin}`]: margin
      },
      className
    );

    return React.createElement(
      "span",
      {
        className: badgeClasses,
        style,
        ...(extraProps || {})
      },
      label
    );
  }
}

Label.defaultProps = {
  size: null,
  margin: false,
  theme: null,
  className: "",
  style: {},
  mutted: false,
  strong: false,
  slim: false,
  text: false,
  upper: false,
  lower: false,
  children: null
};

Label.propTypes = {
  size: PropTypes.oneOf(["small", "x-small"]),
  margin: PropTypes.oneOf([false, "no", "no-top", "no-bottom"]),
  theme: PropTypes.oneOf([
    "default",
    "primary",
    "dark",
    "grey",
    "error",
    "warning",
    "warning-active",
    "success",
    "success-active"
  ]),
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType(PropTypes.string, PropTypes.number)
  ),
  mutted: PropTypes.bool,
  strong: PropTypes.bool,
  slim: PropTypes.bool,
  text: PropTypes.oneOf([false, "left", "center", "right"]),
  upper: PropTypes.bool,
  lower: PropTypes.bool,
  children: PropTypes.node
};

export default Badge;
